import React from 'react';
import { BsWhatsapp, BsLinkedin, BsGithub } from 'react-icons/bs';


const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://wa.me/qr/4AZEBBADKABYB1' target="_blank" rel="noopener noreferrer">
        <BsWhatsapp style={{alignItems:'center'}}/>
      </a>
    </div>
    <div>
      <a href='https://github.com/suriyag2002/' target="_blank" rel="noopener noreferrer">
        <BsGithub style={{alignItems:'center'}}/>
      </a>
    </div>
    <div>
      <a href='https://www.linkedin.com/in/suriya-gunasekaran/' target="_blank" rel="noopener noreferrer">
      <BsLinkedin style={{alignItems:'center'}}/>
      </a>
    </div>
  </div>
);

export default SocialMedia;